"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
export default function SecuritySection() {
  const $ = _c(33);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br className="hidden sm:block" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br className="hidden sm:block" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t7 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins text-2xl sm:text-3xl lg:text-[2.35rem] font-bold text-[#141047] dark:text-white leading-[1.25] mb-8 tracking-tight max-w-xl">Securely Manage Your Practice {t5}with Advanced Privacy and {t6}Data Protection Layers</motion.h2>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <GradientButton href="/contact" variant="peach-pink">Book a Demo <FaChevronRight className="ml-1 text-[12px]" /></GradientButton>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7) {
    t9 = <div className="lg:col-span-7 flex flex-col items-start z-10">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== desktopAnimations) {
    t10 = desktopAnimations ? {
      opacity: 0,
      scale: 0.95
    } : false;
    $[17] = desktopAnimations;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== desktopAnimations) {
    t11 = desktopAnimations ? {
      opacity: 1,
      scale: 1
    } : undefined;
    $[19] = desktopAnimations;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== desktopAnimations) {
    t12 = desktopAnimations ? undefined : {
      opacity: 1,
      scale: 1
    };
    $[21] = desktopAnimations;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      duration: 0.6,
      ease
    };
    t14 = {
      once: true
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t13 = $[23];
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Image src="/images/images/privacy-data.png" alt="Privacy and Data Protection" width={550} height={400} priority={true} className="w-full h-auto object-contain drop-shadow-2xl" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12) {
    t16 = <div className="lg:col-span-5 relative flex justify-center items-center z-20 mt-6 lg:-mt-48 mb-2 lg:mb-0"><motion.div initial={t10} whileInView={t11} animate={t12} transition={t13} viewport={t14} className="w-full max-w-[480px]">{t15}</motion.div></div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16 || $[31] !== t9) {
    t17 = <section className="bg-white dark:bg-gray-950 py-16 md:py-24 px-4 sm:px-6 lg:px-8 font-sans overflow-visible"><div className="max-w-7xl mx-auto pt-16 sm:pt-20 lg:pt-28"><div className="relative bg-gradient-to-r from-[#d9f2ff] via-[#e3f3ff] to-[#f9e8ff] dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 rounded-[2.5rem] p-8 md:p-12 lg:p-16 shadow-sm"><div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">{t9}{t16}</div></div></div></section>;
    $[30] = t16;
    $[31] = t9;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}